import React, { Component } from "react";

function IfFooter({noFooter, ...props}) {
  if(noFooter){
    return (<div></div>);
  }
  else{
    return (<div className="footer">
    {props.legend}
    {props.stats != null ? <hr /> : ""}
    <div className="stats">
      <i className={props.statsIcon} /> {props.stats}
    </div>
  </div>)
  }
}

export class Card extends Component {
  render() {
    return (
      <div className={"card" + (this.props.plain ? " card-plain" : "")}>
        <div className={"header" + (this.props.plain ? " nopadding" : "") + (this.props.hCenter ? " text-center" : "")} style={{background: "aliceblue"}}>
          <h4 className="title">{this.props.title}</h4>
          <p className="category">{this.props.category}</p>
        </div>
        <div
          className={
            "content" +
            (this.props.ctAllIcons ? " all-icons" : "") +
            (this.props.ctTableFullWidth ? " table-full-width" : "") +
            (this.props.ctTableResponsive ? " table-responsive" : "") +
            (this.props.ctTableUpgrade ? " table-upgrade" : "")
          }
        >
          {this.props.content}

           <IfFooter {...this.props} />
        </div>
      </div>
    );
  }
}

export default Card;
